import { IPackInfo, IPackQuestionRecord, IPackRecord } from '@/contracts/modules/education/entities/IPackRecord'

/** Ответ GET /api/education/v1/pack */
export class PackResponse implements IPackRecord {
  pack: IPackInfo | null
  questions: IPackQuestionRecord[]

  constructor({ pack, questions }: { pack: IPackInfo | null, questions: IPackQuestionRecord[] }) {
    this.pack = pack
    this.questions = questions
  }
}
